import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useAdminTheme } from '../../contexts/AdminThemeContext';
import { authAPI } from '../../services/api';
import Loader from '../common/Loader';
import ProfileSection from '../profile/ProfileSection';

const FinanceOperatorProfile = () => {
  const { user: authUser } = useAuth();
  const { isDarkMode } = useAdminTheme();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      setLoading(true);
      const response = await authAPI.getProfile();
      if (response.success) {
        setUser(response.data.user);
      }
    } catch (error) {
      console.error('Error fetching profile:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateSuccess = (updatedUser) => {
    setUser(updatedUser);
  };

  if (loading) {
    return <Loader isDarkMode={isDarkMode} />;
  }

  return (
    <div className={`min-h-screen transition-colors duration-300 ${
      isDarkMode ? 'bg-skyone-page-dark' : 'bg-gray-50'
    }`}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-6">
          <button
            onClick={() => navigate('/finance/dashboard')}
            className={`flex items-center mb-4 px-3 py-2 rounded-md transition-colors duration-200 ${
              isDarkMode
                ? 'text-gray-300 hover:text-white hover:bg-skyone-card-dark'
                : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
            }`}
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back to Dashboard
          </button>
          <h1 className={`text-3xl font-bold transition-colors duration-300 ${
            isDarkMode ? 'text-white' : 'text-gray-900'
          }`}>
            Finance Operator Profile
          </h1>
        </div>

        {/* Profile Section */}
        <ProfileSection 
          user={user || authUser} 
          isDarkMode={isDarkMode}
          onUpdateSuccess={handleUpdateSuccess}
          isPhoneRequired={false}
        />
      </div>
    </div>
  );
};

export default FinanceOperatorProfile;

